import { formatQuantity } from '../format-quantity.js';
/** Mark Delivered's confirm line for one rejected line; a Standard rejection comes back through Receiving. */
export function deliveryRejectionSummary(options) {
    const { path, qty, productName } = options;
    const removed = `${formatQuantity(qty)} of ${productName} will be removed from the order`;
    return path === 'Standard'
        ? `${removed} and wait in Receiving until they're back.`
        : `${removed}.`;
}
//# sourceMappingURL=delivery-rejection-summary.js.map